
import Stack from '@mui/joy/Stack';
import Lore from 'components/Lore';

const LoreFeaturePlaceholder = ({slug}: {slug: string}) => {
    return (<Stack m={1}>
    <Lore slug={slug} />
    </Stack>
    );
};


export default LoreFeaturePlaceholder;
